import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import logoImg from "images/logo.png";
import whiteLogoImg from "images/logo_white.png";
import logoLightImg from "images/logo.png"; // logo-right.png
import { globalCurrentEventId } from "utils/global";
import { getEventLogo, getExhibitionData } from "services/events";
export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
  isWhite?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "flex-shrink-0",
  isWhite = "black"
}) => {
  const [searchParams] = useSearchParams();
  const eventParam = searchParams.get("event");
  const location = useLocation();
  const [logo, setLogo] = useState(img);
  const [type, setType] = useState<string>('');
  const [eventData, setEventData] = useState<any>(null);

  const getLocationInfo = (): { id: string | null; locationType: string } => {
    const event_id = globalCurrentEventId();
    const pathParts = location.pathname.split("/");

    if ( location.pathname == "/" || location.pathname == "/events" || location.pathname == "/dashboard" || pathParts.includes("signup") || pathParts.includes("login")) {
      return { id: null, locationType: '' };
    }

    if (pathParts.includes("floorplans")) {
      return { id: pathParts[pathParts.indexOf("floorplans") + 1], locationType: 'floorplans' };
    }

    if (pathParts.includes("booking")) {
      return { id: eventParam, locationType: 'booking' };
    }

    if (pathParts.includes("exhibitors")) {
      return { id: pathParts[pathParts.indexOf("exhibitors") + 1], locationType: 'exhibitors' };
    }

    if (event_id) {
      return { id: event_id?.toString() || null, locationType: 'admin-exhibitor' };
    }

    return { id: null, locationType: '' };
  };

  // Use useEffect to handle fetching data when location changes
  useEffect(() => {
    const { id, locationType } = getLocationInfo();
    setType(locationType);

    const fetchEvent = async () => {
      try {
        let logoData = null;

        if (locationType === 'floorplans') {
          if (eventParam) { // event
            logoData = await getEventLogo(eventParam || '', 'event');
          } else { // map
            // logoData = await getEventLogo(id || '', 'map');
            const data = await getExhibitionData(id || 'map');
            if (data?.event?.image) {
              logoData = { image: data.event.image, link: data.event?.link };
            }
          }
          // logoData = await getEventLogo(id || '', eventParam || 'map');
        } else if (locationType === 'exhibitors') {
          const data = await getExhibitionData(id || '');
          if (data?.event?.image) {
            logoData = { image: data.event.image, link: data.event?.link };
          }
          setEventData(data);
        } else if (locationType === 'booking') {
          logoData= await getEventLogo(id || '');
        } else if (locationType === 'admin-exhibitor') {
          logoData = await getEventLogo(id || '', 'event');
        }

        if (logoData?.image) {
          setLogo(`${process.env.REACT_APP_BACKEND_URL}/${logoData.image}`);
          if (locationType !== 'exhibitors') {
            setEventData({ event: { image: logoData.image, link: logoData.link } });
          }
        } else {
          setLogo(img);
          setEventData(null);
        }

      } catch (err) {
        console.error("Failed to fetch event logo:", err);
        setLogo(img);
        setEventData(null);
      }
    };

    // Only fetch event if the ID exists
    // if (id) {
      fetchEvent();
    // }
  }, [location.pathname, eventParam]);

  const logoContent = (
    <>
      {logo ? (
        <img
          key={logo}
          className={`block max-h-[50px] sm:max-h-[70px] ${imgLight ? "dark:hidden" : ""
            }`}
          src={isWhite == "black" ? logo : imgLight}
          alt="Logo"
          onError={() => console.log("Error loading image:", logo)}
        />
      ) : (
        "Logo Here"
      )}

      {/* {imgLight && (
        <img
          className="hidden max-h-8 sm:max-h-10 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )} */}
    </>
  );

  const externalLink = eventData?.event?.link;

  return (
    <>
      {externalLink ? (
        <a
          href={externalLink}
          target="_blank"
          rel="noopener noreferrer"
          className={`ttnc-logo inline-block text-slate-600 ${className}`}
        >
          {logoContent}
        </a>
      ) : (
        <Link
          to="/"
          className={`ttnc-logo inline-block text-slate-600 ${className}`}
        >
          {logoContent}
        </Link>
      )}
    </>
  );
};

export default Logo;
